/*********************************************************************************
 *	Sortable table column
 **********************************************************************************
 *
 * Provides UI and click handling for sortable columns.
 * The name of the `column` (attrs.rcSortableColumn) is mandatory. If it is not specified, the directive ignores the element.
 * The name of the server columns (attrs.serverColumns) is a list of comma separated server column names. It is optional and falls back to the value of `column`.
 * Server columns are used when one UI column corresponds to multiple columns on the API.
 * An example of this would be something like a name which is one column (UI) made up of firstName+latsName (API). In this case, the UI column will be `name` and the server columns will be `firstName,lastName`.
 * Another use case would be having different UI and API column names. This is useful when the server column is under another object, e.g. pendingRequest.seatCount.
 *
 */
(function() {
  

  angular.module('rcDirectives.sortableColumn', []).directive('rcSortableColumn', function() {
    return {
      priority: -1,
      restrict: 'A',
      scope: {
        currentSort: '@',
        onClick: '&'
      },
      link: function(scope, element, attrs) {
        var column = attrs.rcSortableColumn;
        //No column specified means no sortable column
        if (!column) {
          return;
        }

        var serverColumns = attrs.serverColumns;
        var isNumeric = attrs.numericSort === 'true';

        //Add the sortable class
        element.addClass('sortable');

        //Watch currentSort to add arrows if the current column is being sorted taking into account the sort direction
        scope.$watch('currentSort', function(currentSort) {
          try {
            currentSort = JSON.parse(currentSort);
          } catch (e) {
            currentSort = null;
          }

          if (currentSort && currentSort.column === column) {
            if (currentSort.direction === 'asc') {
              element.removeClass('sorted-desc');
              element.addClass('sorted sorted-asc');
            } else if (currentSort.direction === 'desc') {
              element.removeClass('sorted-asc');
              element.addClass('sorted sorted-desc');
            }
          } else {
            element.removeClass('sorted sorted-asc sorted-desc');
          }
        });

        //Call onClick() expression when column is clicked
        element.on('click', function() {
          scope.$apply(function() {
            scope.onClick({column: column, serverColumns: serverColumns, isNumeric: isNumeric});
          });
        });
      }
    };
  });
})();
